import React, { useMemo } from "react";

// import { Hidden } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AppConfig, GO_SHARE_COMPANY_IDS, GOSSELIN_MOVING_COMPANY_IDS, LINKS } from "../../../constants";
import { useAppState } from "../../../context/StateContext";
import useCurrentBrand from "../../../hooks/useCurrentBrand";
import { Routes } from "../../../util/enums";
import {
  AboutUs,
  DivColumn,
  DivFlex,
  FooterContainer,
  FooterLink,
  ItemFooter,
  PoweredBy,
  ShipeeziLogo,
  Subtitle,
} from "./styles";
import { Box } from "@mui/material";

const WhiteLogoShipeezi = require("../../../assets/img/white-logo.png");

const Footer = () => {
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();

  const { currentBrand } = useCurrentBrand();

  const isCompanyGosselin: boolean = useMemo(() => {
    if (currentUser?.companyId) {
      return GO_SHARE_COMPANY_IDS.concat(GOSSELIN_MOVING_COMPANY_IDS).includes(
        currentUser?.companyId
      );
    }

    return false;
  }, [currentUser]);

  if (
    !window.location.href.includes(Routes.SIGNIN) &&
    !window.location.href.includes(Routes.ON_BOARDING) &&
    !window.location.href.includes("approve") &&
    !window.location.href.includes(Routes.ESTIMATE_QUOTE) &&
    !window.location.href.includes(Routes.CUSTOMER_PORTAL)
  )
    return (
      <FooterContainer>
        <Box sx={{ display: { sm: "none", md: "block" } }}>
          <DivFlex>
            <AboutUs href={LINKS.aboutUs} rel="noopener noreferrer" target="_blank">
              <Subtitle>{translate("aboutUs")}</Subtitle>
            </AboutUs>
            <FooterLink href="https://shipeezi.com/legal" rel="noopener noreferrer" target="_blank">
              <Subtitle>{translate("privacyPolicy")}</Subtitle>
            </FooterLink>
            {isCompanyGosselin ? (
              <FooterLink
                href={currentUser?.company.webSite || ""}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Subtitle>{currentUser?.company?.name || ""}</Subtitle>
              </FooterLink>
            ) : (
              <ItemFooter>
                <Subtitle>{currentUser?.company?.name || ""}</Subtitle>
              </ItemFooter>
            )}
          </DivFlex>
        </Box>
        <div>
          <Subtitle>{AppConfig.copyRightText}</Subtitle>
        </div>
      </FooterContainer>
    );

  return null;
};

export default Footer;
